import script from "./KAM001-v1.vue?vue&type=script&lang=ts&setup=true"
export * from "./KAM001-v1.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__